'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('./index');

var _index2 = _interopRequireDefault(_index);

var _children = require('../lib/children');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (apiProps) {
  return function ApiDecorator(children, maybeComponent, maybeContext) {
    return maybeContext ? _react2.default.createElement(_index2.default, apiProps, (0, _children.createChildren)(children, maybeComponent)) : ApiDecorator.bind(null, [].concat(children, maybeComponent || []));
  };
};